(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('RootCauseAnalysisFactor', RootCauseAnalysisFactor);

    RootCauseAnalysisFactor.$inject = ['$resource'];

    function RootCauseAnalysisFactor ($resource) {
        var resourceUrl =  'api/root-cause-analysis-factors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
